import React, { Component } from "react";
import ThirdForm from "../ThirdForm/ThirdForm";
/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : Social_BenefitsPage
Description : Componente que contienen el formulario de la pantalla Social_Benefits 
Date Autor Modification
================================================================================
23/10/2021 Cristian Andres Pizo Mina – Se llama al componente Social_BenefitsForm
================================================================================ */
class ThirdPage extends Component{
    render(){
        return(
            <div>                    
                <ThirdForm/>
            </div>
        )   
    }
}

export default ThirdPage;